<template>
    <div>
        <div class="">
            <!-- Modal -->
            <div class="modal fade" id="addCoach" tabindex="-1" aria-labelledby="addCoach" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title title-modal" id="addCoach">Add Coach</h5>
                            <button @click="closeModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-4">
                            <div class="form-group">
                                <label for="email">Coach email address *</label>
                                <div class="input-group">
                                    <input :disabled="updateCoach" v-model="coachForm.email" type="eamil" class="form-control inputt" id="email" placeholder="Enter email address">
                                    <div class="input-group-prepend">
                                        <button style="cursor: pointer; background: #2AB3E6; color: #ffffff;" :disabled="searchLoading || coachForm.email == ''" class="btn btn-outline-secondary" type="button" id="button-addon1" @click="searchCoachEmail">
                                           {{ searchLoading ? 'Seaching...' : ' Search' }}
                                            <i
                                                class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                                v-if="searchLoading"
                                                >
                                            </i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-if="searchedCoachData != null || hideCoachFields">
                                <div class="form-group">
                                    <label for="fullname">Coach first name *</label>
                                    <input :disabled="updateCoach" v-model="coachForm.firstname" type="text" class="form-control inputt" id="firstname" placeholder="Enter first name">
                                </div>
                                <div class="form-group">
                                    <label for="fullname">Coach last name *</label>
                                    <input :disabled="updateCoach" v-model="coachForm.lastname" type="text" class="form-control inputt" id="lastname" placeholder="Enter last name">
                                </div>
                                

                                <div class="form-group">
                                    <label for="phone">Coach phone number</label>
                                    <input :disabled="updateCoach" v-model="coachForm.phone" type="eamil" class="form-control inputt" id="phone" placeholder="Enter phone number">
                                </div>

                                <div class="settings-card">
                                    <!-- Dynamic loop rendering each toggle matching the design -->
                                    <div 
                                        v-for="(item, key) in settings" 
                                        :key="key" 
                                        class="toggle-row"
                                    >
                                        <!-- Responsive Text Label -->
                                        <span class="toggle-label">{{ item.label }}</span>
                                        
                                        <!-- Custom Accessible Switch -->
                                        <button 
                                        type="button" 
                                        class="toggle-switch" 
                                        :class="{ 'is-active': item.value === 'YES' }"
                                        @click="item.value = (item.value === 'YES' ? 'NO' : 'YES')"
                                        :aria-checked="(item.value === 'YES').toString()"
                                        role="switch"
                                        >
                                        <span class="toggle-handle"></span>
                                        </button>
                                        <!-- Custom Accessible Switch -->
                                        <!-- <button 
                                        type="button" 
                                        class="toggle-switch" 
                                        :class="{ 'is-active': item.value }"
                                        @click="item.value = !item.value" // Boolean
                                        @click="item.value = (item.value === 'YES' ? 'NO' : 'YES')" //
                                        :aria-checked="item.value.toString()"
                                        role="switch"
                                        >
                                        <span class="toggle-handle"></span>
                                        </button> -->


                                       
                                    </div>
                                </div>
                            </div>
                       
                        </div>

                        <div class="container">
                            <div class="challenge-list-holder">
                                <div class="challengers-list" v-for="item in coaches" :index="item.id">
                                    <div class="list-c">
                                        <img src="../../assets/images/user-black.svg" alt="">
                                        <p>{{ item.firstname }} {{ item.lastname }}</p>
                                    </div>

                                    <div class="d-flex">
                                        <span class="" style="margin-right: 15px;" @click="selectToEdit(item)">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.8586 3.63524L10.3896 3.10421C11.2695 2.22438 12.6959 2.22438 13.5758 3.10421C14.4557 3.98404 14.4557 5.41053 13.5758 6.29035L13.0448 6.82138M9.8586 3.63524C9.8586 3.63524 9.92506 4.76365 10.9207 5.75933C11.9164 6.75499 13.0448 6.82138 13.0448 6.82138M9.8586 3.63524L4.97672 8.51718C4.64596 8.84785 4.4807 9.01319 4.33849 9.19549C4.17082 9.41052 4.02695 9.6432 3.9097 9.88939C3.81014 10.0981 3.7363 10.3199 3.58836 10.7635L3.11487 12.1839M13.0448 6.82138L8.16277 11.7033C7.83213 12.034 7.66688 12.1993 7.48456 12.3415C7.26953 12.5092 7.0368 12.6531 6.79057 12.7703C6.5819 12.8699 6.36012 12.9437 5.91643 13.0917L4.49611 13.5651M3.11487 12.1839L2.80855 13.103C2.73573 13.3212 2.79264 13.562 2.95535 13.7247C3.11806 13.8874 3.35881 13.9443 3.57702 13.8715L4.49611 13.5651M3.11487 12.1839L4.49611 13.5651" stroke="#5D6F7C" stroke-width="0.88141"/>
                                                <path d="M6.25 14.583H14.5833" stroke="#5D6F7C" stroke-width="1.04167" stroke-linecap="round"/>
                                            </svg>
                                        </span>
                                        <span @click="openDeleteModal(item)">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.2396 4.16699H2.43164" stroke="#5D6F7C" stroke-width="1.04188" stroke-linecap="round"/>
                                                <path d="M13.0825 5.9043L12.763 10.6963C12.6401 12.5403 12.5786 13.4624 11.9778 14.0245C11.377 14.5866 10.4529 14.5866 8.60474 14.5866H8.06761C6.21943 14.5866 5.29536 14.5866 4.69454 14.0245C4.09372 13.4624 4.03225 12.5403 3.90931 10.6963L3.58984 5.9043" stroke="#5D6F7C" stroke-width="1.04188" stroke-linecap="round"/>
                                                <path d="M6.59961 7.64062L6.9469 11.1135" stroke="#5D6F7C" stroke-width="1.04188" stroke-linecap="round"/>
                                                <path d="M10.0719 7.64062L9.72461 11.1135" stroke="#5D6F7C" stroke-width="1.04188" stroke-linecap="round"/>
                                                <path d="M4.51562 4.16773C4.55444 4.16773 4.57384 4.16773 4.59144 4.16729C5.16339 4.15279 5.66795 3.78912 5.86258 3.25111C5.86856 3.23455 5.8747 3.21615 5.88697 3.17932L5.95441 2.97702C6.01197 2.80432 6.04076 2.71797 6.07893 2.64465C6.23125 2.35214 6.51307 2.14903 6.83874 2.09702C6.92036 2.08398 7.0114 2.08398 7.19345 2.08398H9.47821C9.66027 2.08398 9.75133 2.08398 9.83294 2.09702C10.1586 2.14903 10.4404 2.35214 10.5927 2.64465C10.6309 2.71797 10.6597 2.80432 10.7173 2.97702L10.7847 3.17932C10.797 3.2161 10.8031 3.23457 10.8091 3.25111C11.0037 3.78912 11.5083 4.15279 12.0803 4.16729C12.0978 4.16773 12.1172 4.16773 12.156 4.16773" stroke="#5D6F7C" stroke-width="1.04188"/>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
            
                        <div class="form-group save-btn container">
                            <button class="btn" :disabled="coachAdding" @click="addCoachDynamics()" v-if="showSubmitBtn || updateCoach">
                                Save Details
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="coachAdding"
                                    >
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="removeCoach" tabindex="-1" aria-labelledby="addCoach" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title title-modal" id="addCoach">Remove Coach</h5>
                            <button @click="closeModalRemove()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-4">
                            <h4 class="remove-confirmation">Are you sure you want to remove <span>{{ coachItem.firstname }} {{ coachItem.lastname }}</span> as coach of <span>{{ kidItem.firstname }} {{ kidItem.lastname }}</span> ?</h4>
                        </div>
                        <div class="form-group save-btn container">
                            <button class="btn" :disabled="removeCoachLoader" @click="removeCoachFromChild()">
                                Remove
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="removeCoachLoader"
                                    >
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "AddCoach",
    components: {
        PageLoader,
    },

    data() {
        return {
            coachAdding: false,
            searchLoading: false,
            hideCoachFields: false,
            showSubmitBtn: false,
            removeCoachLoader: false,
            selectedValue: 1,
            updateCoach: false,
            coaches: [],
            coachForm: {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                kid_id: "",
                can_publish: "NO"
            },
            accountOptions: [
            ],
            settings: {
                canPublish: { label: 'Can Publish', value: 'NO' },
                // uploadEntries: { label: 'Upload Challenge Entries', value: true },
                // receiveUpdates: { label: 'Receive Updates', value: true },
                // manageParticipation: { label: 'Manage Participation', value: true }
            },
            searchedCoachData: null,
            coachId: "",
            kidItem: "",
            userId: "",
            coachItem: "",

        };
    },
    watch: {
        // Deep watch monitors nested 'value' changes across all settings properties
        settings: {
        deep: true,
            handler(newSettings) {
                // Formats a clean key-value payload: { viewProfile: "YES", uploadEntries: "NO", ... }
                const payload = Object.keys(newSettings).reduce((acc, key) => {
                acc[key] = newSettings[key].value;
                return acc;
                }, {});

                console.log('Detected change! Sending payload:', payload.canPublish);
                this.coachForm.can_publish = payload.canPublish;
            }
        }
    },
    created() {
        const kidItem = JSON.parse(localStorage.getItem('kidDetails'));
        if (kidItem) {
            this.coachForm.kid_id = kidItem.id;
            this.kidItem = kidItem;
            // console.log("CoachForm", this.coachForm)
        }
    },
    mounted() {
        this.fetchCoaches();
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        closeModal() {
            this.coachForm.firstname = '';
            this.coachForm.lastname = '';
            this.coachForm.email = '';
            this.coachForm.phone = '';
            // this.coachForm.kid_id = item.kid_id;
            this.updateCoach = false;
            this.hideCoachFields = false;
            this.coachAdding = false;
            this.searchLoading = false;
            this.showSubmitBtn = false;
            this.searchedCoachData = null
        },  
        async searchCoachEmail() {
            this.updateCoach = false;
            this.hideCoachFields = false;
            this.showSubmitBtn = false;
            this.searchedCoachData = null
            if (this.coachForm.email == '') {
                return this.$store.commit("setApiFailed", "Enter Coach Email");
            }
            this.searchLoading = true;
            try {
                await Api.postRequest("search-coach-by-email", {email: this.coachForm.email}).then(res => {
                    // console.log("CAOACH DATA", res);
                    this.searchLoading = false;
                    this.showSubmitBtn = true;
                    if (res.data.success && res.data.data == null) {
                        this.hideCoachFields = true;
                        return this.$store.commit("setApiFailed", "Coach not found");
                    } 
                    if (res.data.success && res.data.data != null) {
                        this.searchedCoachData = res.data.data;
                        this.hideCoachFields = false;
                        this.coachForm.firstname = res.data.coach_object.firstname;
                        this.coachForm.lastname = res.data.coach_object.lastname;
                        this.coachForm.emailname = res.data.coach_object.email;
                        this.coachForm.phone = res.data.coach_object.phone;
                        this.userId = res.data.data.user_id;
                        return this.$store.commit("setApiSuccess", "Coach found");
                    }   
                    if (res.data.error) {
                        this.showSubmitBtn = false;
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("Error:", err);
                    this.showSubmitBtn = false;
                    this.searchLoading = false;
                    this.showSubmitBtn = true;
                })
            } finally {
                // console.log("closed")
            }
        },
        addCoachDynamics() {
            if (this.searchedCoachData != null) {
                this.addCoachExisting();
            } else {
                this.addCoach();
            }
        },
        async addCoach() {
            if (this.coachForm.firstname == '' || this.coachForm.lastname == '' || this.coachForm.email == '' || this.coachForm.kid_id == '') {
                return this.$store.commit("setApiFailed", "Fill all required informations");
            }
            this.coachAdding = true;
            try {
                await Api.postRequest(`parent-add-coach`, {
                    email: this.coachForm.email,
                    firstname: this.coachForm.firstname,
                    lastname: this.coachForm.lastname,
                    phone: this.coachForm.phone,
                    kid_id: this.coachForm.kid_id,
                    can_publish: this.coachForm.can_publish,
                }).then(res => {
                    this.coachAdding = false;
                    // console.log("Coach Res", res);
                    if (res.data.success) {
                        window.location.reload()
                        this.fetchCoaches();
                        $("#addCoach")
                        .removeClass("fade")
                        .modal("hide");
                        return this.$store.commit("setApiSuccess", res.data.success);
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("error:", err)
                    this.coachAdding = false;
                })
            } finally {
                this.coachAdding = false;
                // console.log("closed")
            }
        },
        async addCoachExisting() {
            if (this.userId == '' || this.coachForm.kid_id == '') {
                return this.$store.commit("setApiFailed", "Fill all required informations");
            }
            this.coachAdding = true;
            try {
                await Api.postRequest(`parent-attach-coach-to-kid`, {
                    coach_user_id: this.userId,
                    kid_id: this.coachForm.kid_id,
                    can_publish: this.coachForm.can_publish,
                }).then(res => {
                    this.coachAdding = false;
                    // console.log("Coach Res", res);
                    if (res.data.success) {
                        window.location.reload()
                        this.fetchCoaches();
                        $("#addCoach")
                        .removeClass("fade")
                        .modal("hide");
                        return this.$store.commit("setApiSuccess", res.data.success);
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("error:", err)
                    this.coachAdding = false;
                })
            } finally {
                this.coachAdding = false;
                // console.log("closed")
            }
        },
        openDeleteModal(item) {
            this.coachItem = item;
            $("#addCoach")
            .removeClass("fade")
            .modal("hide");
            $("#removeCoach")
            .addClass("fade")
            .modal("show");

        },
        closeModalRemove () {
            $("#removeCoach")
            .removeClass("fade")
            .modal("hide");
            $("#addCoach")
            .addClass("fade")
            .modal("show");
        },
        removeCoachFromChild() {
            this.removeCoachLoader = true;
            Api.postRequest('delete-coach-from-kid', {kid_id: this.kidItem.id}).then(res => {
                console.log('delete res', res)
                this.removeCoachLoader = false;
                window.location.reload();
                return this.$store.commit("setApiSuccess", res.data.success);
            }).catch(err => {
                console.log("Error:", err)
                this.removeCoachLoader = false;
            })
        },
        fetchCoaches() {
            Api.getRequest(`parent-fetch-coaches`).then(res => {
                // console.log("Coaches", res);
                if (res.data.success) {
                    this.coaches = res.data.data;
                }
            }).catch(err => {
                console.log("Error:", err);
            })
        },
        
        selectToEdit(item) {
            this.coachForm.firstname = item.firstname;
            this.coachForm.lastname = item.lastname;
            this.coachForm.email = item.email;
            this.coachForm.phone = item.phone;
            this.coachForm.kid_id = item.kid_id;
            this.updateCoach = true;
            this.hideCoachFields = true;
        }
    }
};
</script>


<style scoped lang="scss">
// Moadl come out from bottom

.modal.fade .modal-dialog {
    transform: translate3d(0, 100vh, 0);
    transition: transform 0.3s ease-out;
}

/* Shown state: Slide into view */
.modal.fade.show .modal-dialog {
    transform: translate3d(0, 0, 0);
}

/* Optional: Position at the bottom of the screen */
.modal-bottom .modal-dialog {
    margin: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
}

.title-modal {
    font-family: Nunito;
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
    color: #1C2B3A;
}

.challengers-list-holder {
  margin-top: 10rem;
  border: 1px solid #F5F7FA;
  background: #ffffff;
  border-radius: 10px;
  gap: 10px;
  // padding: 20px 5px;
}

.list-c {
  display: flex;
  align-items: center;
  gap: 15px;
}
.challengers-list {
  border: 1px solid #F5F7FA;
  border-radius: 20px;
  padding: 20px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  img {
    width: 42px;
    height: 42px;
    border-radius: 50px;
    object-fit: cover;
    border: 1px solid #e6e6e6;
  }
  p {
    font-family: Lato;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    color: #1C2B3A;
    text-align: left;
    margin-bottom: 0;
    // padding-left: 10;
  }
  h6 {
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #5D6F7C;
    text-align: right;

  }
}

label {
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #5D6F7C;
    display: flex;
}
.inputt {
    height: 48px;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #e8e9e9;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #242424;
    outline: 0;
    box-shadow: none;

}
.selectedAccount {
    border-bottom: 1px solid #2EBFCA;
    border-radius: 10px;
}

.save-btn {
    margin-top: 10px;
    margin-bottom: 20px;
    button {
        background: #2AB3E6;
        color: #ffffff;
        border-radius: 50px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
}

.remove-confirmation {
    font-family: Lato;
    font-size: 19px;
    color: #222930;
    font-weight: 400;
    text-align: center;
    line-height: 28px;
    span {
        text-transform: uppercase;
        font-weight: 600;
    }
}




// toggle btn starts
/* Card container mirroring the subtle off-white background tint */
.settings-card {
  background-color: #f6f7fb;
  border-radius: 24px;
  width: 100%;
  max-width: 560px; /* Adapts dynamically down to mobile widths */
  padding: 12px 0;
  box-sizing: border-box;
}

/* Flexbox row layout */
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  width: 100%;
  box-sizing: border-box;
  gap: 16px;
}

/* Typography styles */
.toggle-label {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 16px;
  color: #5c6470;
  font-weight: 400;
  user-select: none;
  max-width: 70%;
  word-wrap: break-word;
}

/* Outer Track Switch */
.toggle-switch {
  position: relative;
  width: 60px;
  height: 34px;
  background-color: #cbd5e1; /* Inactive track color */
  border-radius: 34px;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.25s ease;
  flex-shrink: 0; /* Keeps toggle perfectly round on narrow viewports */
  outline: none;
}

/* Active Track Color Matching Image */
.toggle-switch.is-active {
  background-color: #2AB3E6;
}

/* Sliding Handle Knob */
.toggle-handle {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 28px;
  height: 28px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: transform 0.25s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

/* Shift Knob Right */
.toggle-switch.is-active .toggle-handle {
  transform: translateX(26px);
}

/* Focus Ring for Keyboard Users */
.toggle-switch:focus-visible {
  box-shadow: 0 0 0 3px rgba(90, 174, 227, 0.4);
}

/* Responsive Scaling Breakpoint */
@media (max-width: 360px) {
  .toggle-row {
    padding: 12px 16px;
  }
  .toggle-label {
    font-size: 14px;
  }
  .toggle-switch {
    width: 52px;
    height: 30px;
  }
  .toggle-handle {
    width: 24px;
    height: 24px;
  }
  .toggle-switch.is-active .toggle-handle {
    transform: translateX(22px);
  }
}

// Toggle Btn ends
</style>

